import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { buildWhatsAppLink, PHONE } from "../data/menu";

export const WhatsAppFAB = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {open && (
        <div
          data-testid="whatsapp-fab-card"
          className="bg-[#FFFDF9] rounded-2xl shadow-[0_25px_50px_rgba(62,39,35,0.25)] border border-[#3E2723]/10 p-4 w-72 animate-in fade-in slide-in-from-bottom-3"
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="font-display font-extrabold text-[#3E2723]">
                ¿Pedimos algo?
              </div>
              <div className="text-xs text-[#5D4037] mt-1 font-body">
                Te respondemos por WhatsApp al instante.
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-fab-close"
              aria-label="Cerrar"
              className="w-7 h-7 grid place-items-center rounded-full hover:bg-[#FDF8E1] text-[#3E2723]"
            >
              <X size={14} />
            </button>
          </div>
          <a
            href={buildWhatsAppLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-fab-cta"
            className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-4 py-2.5 font-bold text-sm hover:bg-[#1fb957]"
          >
            <MessageCircle size={15} /> Chatear ({PHONE})
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-fab"
        aria-label="WhatsApp"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_18px_35px_rgba(37,211,102,0.45)] animate-pulse-glow hover:scale-105 transition-transform"
      >
        <MessageCircle size={24} />
      </button>
    </div>
  );
};

export default WhatsAppFAB;
